import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NoAccessGuard implements CanActivate {
  static allowAccess = false;

  constructor(private router: Router) {}

  canActivate(): boolean {
    if (!NoAccessGuard.allowAccess) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}